<template>
  <a-spin :spinning="confirmLoading">
    <j-form-container>
      <a-form-model ref="form" :model="model" slot="detail">
        <a-row :disabled="formDisabled">
          <a-col :span="12" v-if="processModel.applicationCode.indexOf('ipsys')==-1">
            <a-form-model-item
              :label="language['eletronicSigned.processNo']"
              :labelCol="labelCol"
              :wrapperCol="wrapperCol"
              ><!-- prop="applicationCode"-->
              <a-input v-model="model.process_no" placeholder="" :disabled="isDisabled"></a-input>
            </a-form-model-item>
          </a-col>
          <a-col :span="12" v-if="processModel.applicationCode.indexOf('ipsys')==-1">
            <a-form-model-item
              :label="language['eletronicSigned.startTime']"
              :labelCol="labelCol"
              :wrapperCol="wrapperCol"
            >
              <a-date-picker
                style="width: 100%"
                :disabled="isDisabled"
                v-model="model.start_time_java"
                :format="dateFormat"
                :getCalendarContainer="(node) => node.parentNode"
              />
            </a-form-model-item>
          </a-col>
          <!-- <a-col :span="24">
            <a-form-model-item
              label="紧急程度"
              :labelCol="labelCol"
              :wrapperCol="wrapperCol">
              <a-radio-group v-model="model.urgent_degree" :disabled="isDisabled">
                <a-radio value="特急件">特急件</a-radio>
                <a-radio value="急件">急件</a-radio>
                <a-radio value="一般件">一般件</a-radio>
              </a-radio-group>
            </a-form-model-item>
          </a-col>-->
        </a-row>
        <a-tabs
          @change="changeTabs"
          default-active-key="1"
          size="large"
          :tab-bar-style="{ marginBottom: '12px', paddingLeft: '16px' }"
        >
          <a-tab-pane
            loading="true"
            :tab="tabName"
            key="1"
            :style="
              innerFullscreen === false
                ? setEdit === true
                  ? `max-height: 32vh;overflow:scroll;`
                  : `max-height: 45vh;overflow:scroll;`
                : setEdit === true
                ? `max-height: 54vh;overflow:scroll;`
                : `max-height: 65vh;overflow:scroll;`
            "
          >
            <div v-if="processModel.applicationCode === 'env_audit'">
              <!--<env-form ref="realForm" ></env-form>-->
<!--              <danger-sign-form ref="applicationModel" :formNo="ipsys_aid" :formCode="formCode"></danger-sign-form>-->
              <a-form-model-item :labelCol="labelCol" :wrapperCol="wrapperCol"> </a-form-model-item>
              <!--<a-empty>111111</a-empty>-->
              <!--<a-form-model-item  :labelCol="labelCol" :wrapperCol="wrapperCol">
              </a-form-model-item>
              <a-form-model-item  :labelCol="labelCol" :wrapperCol="wrapperCol">
              </a-form-model-item>
              <a-form-model-item  :labelCol="labelCol" :wrapperCol="wrapperCol">
              </a-form-model-item>-->
            </div>
          </a-tab-pane>
          <a-tab-pane
            :tab="language['eletronicSigned.processChart']"
            key="4"
            :style="
              innerFullscreen === false
                ? setEdit === true
                  ? `max-height: 32vh;overflow:scroll`
                  : `max-height: 45vh;overflow:scroll`
                : setEdit === true
                ? `max-height: 45vh;overflow:scroll`
                : `max-height: 65vh;overflow:scroll`
            "
          >
            <img style="width: 100%" :src="getProcessChart()" />
          </a-tab-pane>
        </a-tabs>
        <a-card
          :bordered="false"
          :title="
            processModel.applicationCode === 'ipsys' && model.task_code === 'ApproveTask8'
              ? ''
              : language['eletronicSigned.signOpinion']
          "
          v-if="setEdit"
        >
          <div v-if="processModel.applicationCode === 'ipsys'">
            <a-row v-if="!(model.task_code === 'ApproveTask8')">
              <a-textarea v-model="model.comments" maxlength="200"></a-textarea>
            </a-row>
            <div style="text-align: center">
              <!--<a-button style="color: blue;" @click="agree" v-if="model.task_code==='ApproveTask8'">{{language['eletronicSigned.sendOut']}}</a-button>-->
              <a-button
                style="color: blue; right: 20px; padding-left: 30px; padding-right: 30px"
                @click="agree"
                v-if="!(model.task_code === 'ApproveTask8')"
                >{{ language['eletronicSigned.agree'] }}</a-button
              >
              <a-button
                style="color: red; left: 20px; padding-left: 30px; padding-right: 30px"
                @click="reject"
                v-if="!(model.task_code === 'ApproveTask8')"
                >{{ language['eletronicSigned.reject'] }}</a-button
              >
            </div>
          </div>
          <div v-else-if="processModel.modelCode === 'cst_check' && model.task_code === 'Applicant'">
            <a-row>
              <a-textarea v-model="model.comments" maxlength="200"></a-textarea>
            </a-row>
            <div style="text-align: center">
              <a-button style="color: blue; right: 20px; padding-left: 30px; padding-right: 30px" @click="agree">{{
                language['eletronicSigned.agree']
              }}</a-button>
              <!--              <a-button style="color: red;left: 20px;padding-left: 30px;padding-right: 30px;" @click="reject" >{{language['eletronicSigned.reject']}}</a-button>-->
            </div>
          </div>
          <div v-else-if="processModel.modelCode === 'cst_interrupt_confirm' && model.task_code === 'Operator'">
            <a-row>
              <a-textarea v-model="model.comments" maxlength="200"></a-textarea>
            </a-row>
            <div style="text-align: center">
              <a-button style="color: blue; right: 20px; padding-left: 30px; padding-right: 30px" @click="agree">{{
                language['eletronicSigned.agree']
              }}</a-button>
              <!--              <a-button style="color: red;left: 20px;padding-left: 30px;padding-right: 30px;" @click="reject" >{{language['eletronicSigned.reject']}}</a-button>-->
            </div>
          </div>
          <div v-else-if="processModel.modelCode === 'cst_interrupt_recovery' && model.task_code === 'FireResponsible'">
            <a-row>
              <a-textarea v-model="model.comments" maxlength="200"></a-textarea>
            </a-row>
            <div style="text-align: center">
              <a-button style="color: blue; right: 20px; padding-left: 30px; padding-right: 30px" @click="agree">{{
                language['eletronicSigned.agree']
              }}</a-button>
              <!--              <a-button style="color: red;left: 20px;padding-left: 30px;padding-right: 30px;" @click="reject" >{{language['eletronicSigned.reject']}}</a-button>-->
            </div>
          </div>
          <div v-else-if="processModel.applicationCode === 'ipsystbs'">
            <span style="color: #6200ff">{{ language['ipsystbs.signingAlter'] }}</span>
            <a-row>
              <a-textarea v-model="model.comments" maxlength="300"></a-textarea>
            </a-row>
            <div style="text-align: center">
              <a-button style="color: blue; right: 20px; padding-left: 30px; padding-right: 30px" @click="agree">{{
                language['eletronicSigned.agree']
              }}</a-button>
              <a-button style="color: red; left: 20px; padding-left: 30px; padding-right: 30px" @click="reject">{{
                language['eletronicSigned.reject']
              }}</a-button>
            </div>
          </div>
          <div v-else>
            <a-row>
              <a-textarea v-model="model.comments" maxlength="1000"></a-textarea>
            </a-row>
            <div style="text-align: center">
              <a-button style="color: blue; right: 20px; padding-left: 30px; padding-right: 30px" @click="agree">{{
                language['eletronicSigned.agree']
              }}</a-button>
              <a-button style="color: red; left: 20px; padding-left: 30px; padding-right: 30px" @click="reject">{{
                language['eletronicSigned.reject']
              }}</a-button>
            </div>
          </div>
        </a-card>
        <!--<a-card v-if="showAllApprover" :loading="loading" :bordered="false" title="签核人" :style="{ marginTop: '24px' }">
          <a-table :columns="approverColumns" size="middle"
                   :data-source="approverData" :pagination="false" :loading="loading" ></a-table>
        </a-card>-->
      </a-form-model>
    </j-form-container>
  </a-spin>
</template>

<script>
import { ACCESS_TOKEN, USER_LANGUAGE } from '@/store/mutation-types'
import { httpAction, getAction, postAction } from '@/api/manage'
import JInput from '@/components/jeecg/JInput'
import ATextarea from 'ant-design-vue/es/input/TextArea'
import EnvForm from './EnvForm'
// import {epm_agree} from '../auditJS/agree'
import { agree } from '../auditJS/agree'
import { reject } from '../auditJS/reject'

import JFilePop from '@/components/jeecg/minipop/JFilePop'



export default {
  name: 'MyToForm',
  components: {
    ATextarea,
    JInput,
    JFilePop,

  },
  props: {
    //表单禁用
    disabled: {
      type: Boolean,
      default: false,
      required: false,
    },
    innerFullscreen: {
      type: Boolean,
    },
    setEdit: {
      type: Boolean,
    },
  },
  data() {
    const { language } = this.$store.getters
    return {
      langCode: window.sessionStorage.getItem(USER_LANGUAGE),
      // fileUrls:["http://10.134.130.115:9000/plattest/temp/1_1640403353336.jpg","http://10.134.130.115:9000/plattest/temp/2_1640403353336.jpg"],
      fileUrls: [],
      ipsys_aid: '',
      formCode: '',
      taskCode: '',
      orderNo: 0,
      pageType: 'myTodo',
      // setEdit:false,
      tabName: '',
      singTableName:language['eletronicSigned.signList'],
      epDanger: {},
      dateFormat: 'YYYY-MM-DD',
      showAllApprover: true,
      isDisabled: true,
      processChartPrefix: '',
      processChartSuffix: '',
      processGuid: '',
      loading: true,
      model: {},
      labelCol: {
        xs: { span: 24 },
        sm: { span: 6 },
      },
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 16 },
      },
      labelCol2: {
        xs: { span: 24 },
        sm: { span: 3 },
      },
      wrapperCol2: {
        xs: { span: 24 },
        sm: { span: 20 },
      },
      confirmLoading: false,
      approverData: [
        /*{
            key: '10',
            approverOrgLevelNo: 'John Brown',
            approverName: 32,
            approverEmail: 'New York No. 1 Lake Park',
          },*/
      ],
      dataSource: [
        /*{
            key: '1',
            taskTextLocalLang: '隐患单（A）',
            approverName: 'W0105000',
            approveResult: '同意',
            approveComments: '你说的都对',
            approveDate: '2021-10-11',
          },
          */
      ],
      process_guid: '',
      url: {
        loadApproveResult: '/sys/wfapi/loadApproveResultGet', //获取签核记录
        getAllTaskApproversInfo: '/sys/wfapi/getAllTaskApproversInfo', //获取所有签核人
        loadEpDangerInfo: '/epm/publicApi/loadEpDangerInfoByFormNo',
      },
      processModel: {},
      fileAttribute: {
        fileMultiple: true,
        fileDisabled: false,
        number: 1,
      },
    }
  },
  computed: {
    language() {
      return this.$store.getters.language
    },
    columns() {
      if (this.language) {
        return [
          {
            title: this.language['eletronicSigned.taskText'],
            align: 'center',
            dataIndex: 'taskTextLocalLang',
            width: 120,
            customRender: function (text, r, index) {
              if (
                window.sessionStorage.getItem(USER_LANGUAGE) === 'zh_CN' ||
                window.sessionStorage.getItem(USER_LANGUAGE) === 'zh_TW'
              ) {
                return r.taskTextLocalLang
              } else {
                return r.taskTextEn
              }
            },
          },
          {
            title: this.language['eletronicSigned.signPerson'],
            align: 'center',
            width: 100,
            dataIndex: 'approverName',
          },
          {
            title: this.language['eletronicSigned.signResult'],
            align: 'center',
            width: 80,
            dataIndex: 'approveResult',
            scopedSlots: { customRender: 'approveResult' },
            /*customRender: function (text, r, index) {
                if(window.sessionStorage.getItem(USER_LANGUAGE) === "zh_CN" || window.sessionStorage.getItem(USER_LANGUAGE) === "zh_TW"){
                  return r.approveResult;
                }else{
                  return r.approveResult_en;
                }
              }*/
          },
          {
            title: this.language['eletronicSigned.signOpinion'],
            align: 'center',
            width: 80,
            dataIndex: 'approveComments',
          },
          {
            title: this.language['eletronicSigned.signDate'],
            align: 'center',
            width: 100,
            dataIndex: 'approveDate',
          },
        ]
      }
    },
    approverColumns() {
      if (this.language) {
        return [
          {
            title: this.language['eletronicSigned.taskText'],
            align: 'center',
            dataIndex: 'taskTextLocalLang',
            customRender: function (text, r, index) {
              if (
                window.sessionStorage.getItem(USER_LANGUAGE) === 'zh_CN' ||
                window.sessionStorage.getItem(USER_LANGUAGE) === 'zh_TW'
              ) {
                return r.taskTextLocalLang
              } else {
                return r.taskCode
              }
            },
          },
          {
            title: this.language['eletronicSigned.signPersonWorkNo'],
            align: 'center',
            dataIndex: 'approverCode',
          },
          {
            title: this.language['eletronicSigned.signPerson'],
            align: 'center',
            dataIndex: 'realname',
          },
          {
            title: this.language['eletronicSigned.signPersonMail'],
            align: 'center',
            dataIndex: 'email',
          },
        ]
      }
    },
    formDisabled() {
      return this.disabled
    },
  },

  created() {
    //备份model原始值
    this.modelDefault = JSON.parse(JSON.stringify(this.model))
    console.log('current processGuid --> ' + this.model.processGuid)
    getAction('/sys/wfapi/getProcessChart', {}).then((res) => {
      if (res.success) {
        this.processChartPrefix = res.result.prefix
        this.processChartSuffix = res.result.suffix
      }
    })
  },

  methods: {
    handleChange(file) {
      let filemap = {}
      let detileList = []
      if (file) {
        this.fileUrls = file.split(',')
        file.split(',').forEach((item, index) => {
          let map = {}
          map.fileName = item.substring(item.lastIndexOf('/') + 1)
          map.sort = index
          map.filePath = item
          detileList.push(map)
        })
      }
      filemap.pfBpmFileDetailList = detileList
      this.model.file = filemap
    },
    changeTabs(activeKey) {
      if (activeKey != '1') {
        this.showAllApprover = false
      } else {
        this.showAllApprover = true
      }
    },
    getAllTaskApproversInfo(processGuid) {
      this.loading = true
      let formData = {
        processGuid: processGuid,
      }
      postAction(this.url.getAllTaskApproversInfo, formData)
        .then((res) => {
          if (res.success) {
            const result = res.result
            this.approverData = result.map((v, i) => {
              v.key = i + 1
              return v
            })
          }
        })
        .finally(() => {
          this.loading = false
        })
    },

    loadApproveResult(bussinessFormNo) {
      this.loading = true
      let formData = {
        formNo: bussinessFormNo,
        process_guid: this.process_guid,
      }
      getAction(this.url.loadApproveResult, formData)
        .then((res) => {
          if (res.success) {
            const result = res.result
            this.dataSource = result.map((v, i) => {
              v.key = i + 1
              return v
            })
          }
        })
        .finally(() => {
          this.loading = false
        })
    },

    getProcessChart() {
      let processGuid = this.model.process_guid
      // return this.processChartPrefix + processGuid + this.processChartSuffix  + "?timestamp="+ new Date().getTime();
      let imgChartSrc = this.processChartPrefix + processGuid + this.processChartSuffix
      if (imgChartSrc.split('?').length > 1) {
        imgChartSrc = imgChartSrc + '&timestamp=' + new Date().getTime()
      } else {
        imgChartSrc = imgChartSrc + '?timestamp=' + new Date().getTime()
      }
      return imgChartSrc
    },
    //同意
    agree() {
      /*let map = {};
        map.pfBpmProcessId = this.model.process_guid;
        map.comments = this.model.comments;
        map.workNo = this.$store.getters.userInfo.workNo;
        map.approveAction = "Agree";
        map.taskCode = this.model.task_code;
        this.confirmLoading = true;
        getAction("/sys/wfapi/pageToRunProcess", map).then((res) => {
          if (res.success) {
            this.$emit('close');
            this.confirmLoading = false;
          }
        })*/
      let modelCode = this.processModel.modelCode
      if (
        modelCode === 'cst_high' ||
        modelCode === 'cst_hoisting' ||
        modelCode === 'cst_confined_space' ||
        modelCode === 'cst_temporary_electricity'
      ) {
        let validateResult = this.$refs.applicationModel.validateSiteSurvey(modelCode)
        if (validateResult !== 'success') {
          this.$message.warning(validateResult)
          return
        }
      }

      if (modelCode === 'cst_check') {
        let checkApprovedCallbackBefore = this.$refs.applicationModel.checkApprovedCallbackBefore()
        if (checkApprovedCallbackBefore != '') {
          this.$message.warning(checkApprovedCallbackBefore)
          return
        }
      }

      if (modelCode === 'labor_change') {
        let checkEvaluate = this.$refs.applicationModel.checkEvaluate()
        if (checkEvaluate != '') {
          this.$message.warning(checkEvaluate)
          return
        }
        if (
          this.taskCode == 'FactoryLaborAdmin' ||
          this.taskCode == 'Electromechanical' ||
          this.taskCode == 'Fire' ||
          this.taskCode == 'Environment'
        ) {
          this.agreeBack()
        } else {
          this.isAgree()
        }
      } else {
        // ---------------------------- 原始邏輯 ----------------------------
        if (this.processModel.modelCode === 'cst_flame' || this.processModel.modelCode === 'cst_gas') {
          this.agreeBack()
        } else {
          this.isAgree()
        }
        // ---------------------------- 原始邏輯 ----------------------------
      }
    },

    isAgree() {
      agree(this.processModel.applicationCode, this)
    },
    agreeBack() {
      this.$refs.applicationModel.submitForm()
    },
    //驳回
    reject() {
      /*let map = {};
        map.pfBpmProcessId = this.model.process_guid;
        map.comments = this.model.comments;
        map.workNo = this.$store.getters.userInfo.workNo;
        map.approveAction = "Reject";
        map.taskCode = this.model.task_code;
        if(map.comments===null||map.comments===''||map.comments===undefined){
          this.$message.warning("驳回信息不能为空！");
          return;
        }
        this.confirmLoading = true;
        getAction("/sys/wfapi/pageToRunProcess", map).then((res) => {
          if (res.success) {
            this.$emit('close');
            this.confirmLoading = false;
          }
        })*/
      let boo = reject(this.processModel.applicationCode, this)
      if (boo) {
        // this.$refs.applicationModel.submitForm('reject');
      }
    },
    add() {
      this.edit(this.modelDefault)
    },

    edit(record) {
      // this.setEdit = record.setEdit!==null&&record.setEdit!==''&&record.setEdit!==undefined?record.setEdit:false;
      this.model = Object.assign({}, record)
      this.visible = true
      this.process_guid = this.model.process_guid
      if (record.model_code == 'HiddenDangerForm') {
        this.tabName = this.language['eletronicSigned.dangerTabName']
        this.formCode = 'HiddenDangerForm'
        this.getMode(record)
      } else if (record.model_code == 'DelayForm') {
        this.tabName = this.language['eletronicSigned.deferTabName']
        this.formCode = 'DelayForm'
        this.getMode(record)
      } else if (record.model_code == 'IpsTrademarkUserReport') {
        this.tabName = this.language['eletronicSigned.IpsTrademarkUserReportTabName']
        this.formCode = 'IpsTrademarkUserReport'
        this.getMode(record)
      } else if (record.model_code == 'IpsTrademarkUserReportC') {
        this.tabName = this.language['eletronicSigned.IpsTrademarkUserReportTabName']
        this.formCode = 'IpsTrademarkUserReportC'
        this.getMode(record)
      } else if (record.model_code == 'IpsTechnologProposal') {
        this.tabName = this.language['ElectronicSigned.technologyDisclosureCase']
        this.formCode = record.model_code
        this.getMode(record)
      } else if (record.model_code == 'IpsTechnicalBusinessSecrets') {
        this.tabName = this.language['ElectronicSigned.TechnicalBusinessSecrets']
        this.formCode = record.model_code
        this.getMode(record)
      } else if (record.model_code == 'IpsTechnologyDisclosureEvaluate'||record.model_code == 'IpsTechnologyDisclosureEvaluateB') {
        this.tabName = this.language['ElectronicSigned.technologyDisclosureEvaluate']
        this.singTableName=this.language['eletronicSigned.tecApplysignInfor']
        this.formCode = record.model_code
        this.getMode(record)
      } else if (record.model_code == 'IpsTrademarkApplyRegister') {
        this.tabName = this.language['eletronicSigned.IpsTrademarkUserReportTabName']
        this.formCode = 'IpsTrademarkApplyRegister'
        this.getMode(record)
      }else if (record.model_code == 'IpsTrademarkRetrieve') {
        this.tabName = this.language['ipsys.easyQuery']
        this.formCode = 'IpsTrademarkRetrieve'
        this.getMode(record)
      } else if (record.model_code == 'ipsysturUpdateData') {
        this.tabName = this.language['ipsys.turCorrectionRequest']
        this.formCode = record.model_code
        this.getMode(record)
      }else if (record.model_code == 'IpsCopyrightApply') {
        this.tabName = this.language['ipsys.crApplication']
        this.formCode = record.model_code
        this.getMode(record)
      } else if (record.model_code == 'waterForm') {
        this.tabName = this.language['eletronicSigned.waterFormTabName']
        this.formCode = 'waterForm'
        this.getMode(record)
      } else if (record.model_code == 'wasteWaterForm') {
        this.tabName = this.language['eletronicSigned.wasteWaterForm']
        this.formCode = 'wasteWaterForm'
        this.getMode(record)
      } else if (record.model_code == 'cfForm') {
        this.tabName = this.language['eletronicSigned.envinfoCfForm']
        this.formCode = 'cfForm'
        this.getMode(record)
      } else if (record.model_code == 'gasForm') {
        this.tabName = this.language['eletronicSigned.gasFormTabName']
        this.formCode = 'gasForm'
        this.getMode(record)
      } else if (record.model_code == 'trashForm') {
        this.tabName = this.language['eletronicSigned.trashFormTabName']
        this.formCode = 'trashForm'
        this.getMode(record)
      } else if (record.model_code == 'SweepDelayForm') {
        this.tabName = this.language['eletronicSigned.SweepDelayTabName']
        this.formCode = 'SweepDelayForm'
        this.getMode(record)
      } else if (record.model_code == 'SweepHiddenDangerForm') {
        this.tabName = this.language['eletronicSigned.SweepHiddenDangerTabName']
        this.formCode = 'SweepHiddenDangerForm'
        this.getMode(record)
      } else if (record.model_code == 'esg_kpiForm') {
        this.tabName = this.language['esg.kpi.update']
        this.formCode = 'esg_kpiForm'
        this.getMode(record)
      } else if (record.model_code == 'esg_kpiForm_outLeader') {
        this.tabName = this.language['esg.kpi.update']
        this.formCode = 'esg_kpiForm_outLeader'
        this.getMode(record)
      } else if (record.model_code == 'esg_kpiDisForm') {
        this.tabName = this.language['esg.cancleKpi']
        this.formCode = 'esg_kpiDisForm'
        this.getMode(record)
      } else if (record.model_code == 'esg_kpiDisBgChange') {
        this.tabName = this.language['esg.kpiDisBgChange']
        this.formCode = 'esg_kpiDisBgChange'
        this.getMode(record)
      } else if (record.model_code == 'esg_kpiDisBuChange') {
        this.tabName = this.language['esg.kpiDisBuChange']
        this.formCode = 'esg_kpiDisBuChange'
        this.getMode(record)
      } else if (record.model_code == 'esg_kpiDisBgCancle') {
        this.tabName = this.language['esg.kpiDisBgCancle']
        this.formCode = 'esg_kpiDisBgCancle'
        this.getMode(record)
      } else if (record.model_code == 'esg_kpiDisBuCancle') {
        this.tabName = this.language['esg.kpiDisBuCancle']
        this.formCode = 'esg_kpiDisBuCancle'
        this.getMode(record)
      } else if (record.model_code == 'labor_change') {
        this.tabName = this.language['labor.change.newApply'] //'變更申請';
        this.formCode = 'labor_change'
        this.getMode(record)
      } else if (record.model_code == 'labor_change_close') {
        this.tabName = this.language['labor.change.closeApply'] //'結案申請';
        this.formCode = 'labor_change_close'
        this.getMode(record)
      } else if (record.model_code == 'showroom_order') {
        this.tabName = 'showroom参访' //'showroom参访';
        this.formCode = 'showroom_order'
        this.getMode(record)
      } else if (record.model_code == 'cst_apply') {
        this.tabName = this.language['cst.requestOrder']
        this.formCode = 'cst_apply'
        this.getMode(record)
      } else if (record.model_code == 'cst_delay') {
        this.tabName = this.language['cst.delayRequestOrder']
        this.formCode = 'cst_delay'
        this.getMode(record)
      } else if (record.model_code == 'cst_report') {
        this.tabName = this.language['cst.reportOrder']
        this.formCode = 'cst_report'
        this.getMode(record)
      } else if (record.model_code == 'cst_night') {
        this.tabName = this.language['cst.nightOrder']
        this.formCode = 'cst_night'
        this.getMode(record)
      } else if (record.model_code == 'cst_survey') {
        this.tabName = this.language['cst.surveyCheckOrder'] + '-' + this.language['cst.surveyProcess']
        this.formCode = 'cst_survey'
        this.getMode(record)
      } else if (record.model_code == 'cst_check') {
        this.tabName = this.language['cst.surveyCheckOrder'] + '-' + this.language['cst.checkProcess']
        this.formCode = 'cst_check'
        this.getMode(record)
      } else if (record.model_code == 'cst_interrupt') {
        this.tabName = this.language['cst.interruptOrder']
        this.formCode = 'cst_interrupt'
        this.getMode(record)
      } else if (record.model_code == 'cst_interrupt_confirm') {
        this.tabName = this.language['cst.interruptOrder'] + '-' + this.language['cst.interruptProcess']
        this.formCode = 'cst_interrupt_confirm'
        this.getMode(record)
      } else if (record.model_code == 'cst_interrupt_recovery') {
        this.tabName = this.language['cst.interruptOrder'] + '-' + this.language['cst.recoveryProcess']
        this.formCode = 'cst_interrupt_recovery'
        this.getMode(record)
      } else if (record.model_code == 'cst_flame') {
        this.tabName = this.language['cst.flameContructDailyOrder']
        this.formCode = 'cst_flame'
        this.getMode(record)
      } else if (record.model_code == 'cst_gas') {
        this.tabName = this.language['cst.gas.order']
        this.formCode = 'cst_gas'
        this.getMode(record)
      } else if (record.model_code == 'cst_exception') {
        this.tabName = this.language['Abnormal.list.project.not.started'] //'未开工异常单审批流程'
        this.formCode = 'cst_exception'
        this.getMode(record)
      } else if (record.model_code == 'cst_high') {
        this.tabName = this.language['cst.specialOperate'] + '-' + this.language['cst.specialHighOrder']
        this.formCode = 'cst_high'
        this.getMode(record)
      } else if (record.model_code == 'cst_hoisting') {
        this.tabName = this.language['cst.specialOperate'] + '-' + this.language['cst.specialHoistingOrder']
        this.formCode = 'cst_hoisting'
        this.getMode(record)
      } else if (record.model_code == 'cst_confined_space') {
        this.tabName = this.language['cst.specialOperate'] + '-' + this.language['cst.specialCsOrder']
        this.formCode = 'cst_confined_space'
        this.getMode(record)
      } else if (record.model_code == 'cst_temporary_electricity') {
        this.tabName = this.language['cst.specialOperate'] + '-' + this.language['cst.specialTeOrder']
        this.formCode = 'cst_temporary_electricity'
        this.getMode(record)
      } else if (record.model_code == 'cst_carry') {
        this.tabName = this.language['construct.deviceCarry'] + '-' + this.language['common.apply']
        this.formCode = 'cst_carry'
        this.getMode(record)
      } else if (record.model_code == 'AuditWorkflow') {
        this.tabName = this.language['food.audit'] + '-' + this.language['common.apply']
        this.formCode = 'AuditWorkflow'
        this.getMode(record)
      } else if (record.model_code == 'PutOnRecordWorkflow') {
        this.tabName = this.language['food.scba'] + '-' + this.language['common.apply']
        this.formCode = 'PutOnRecordWorkflow'
        this.getMode(record)
      }

      this.loadApproveResult(this.model.business_form_no)
      this.getAllTaskApproversInfo(this.model.process_guid)
      this.loadFile(this.model.process_guid)
      // this.loadEpDangerInfo(this.model.business_form_no, this.model.model_code);
    },
    //加载附件
    loadFile(processGuid) {
      getAction('/sys/processSigned/pfBpmFile/queryByProcessGuid?processGuid=' + processGuid).then((res) => {
        if (res.success) {
          this.fileUrls = []
          let data = res.result
          data.pfBpmFileDetailList.forEach((item) => {
            this.fileUrls.push(item.filePath)
          })
          this.model.file = data
        }
      })
    },
    //查询对应的流程model
    getMode(record) {
      if (record.model_guid) {
        getAction('/sys/processSigned/pfBpmModel/queryBymodelGuId?modelGuId=' + record.model_guid, {}).then((res) => {
          if (res.success) {
            this.processModel = res.result
            this.ipsys_aid = record.business_form_no
            this.taskCode = record.task_code

            let params = {
              processGuid: this.process_guid,
              taskCode: this.taskCode,
              workNo: this.$store.getters.userInfo.workNo,
            }
            getAction('/sys/wfapi/getTaskApproversSetting', params).then((res) => {
              if (res.success) {
                this.orderNo = res.result
              }
            })

            /*if(res.result.applicationCode === 'env_audit'){
                this.ipsys_aid = record.business_form_no;
              }else if(res.result.applicationCode === 'ipsys'){
                this.ipsys_aid = record.business_form_no;
              }*/
          }
        })
      }
    },
    //根据业务单号查询
    loadEpDangerInfo(business_form_no, model_code) {
      let param = {
        formNo: business_form_no,
        modelCode: model_code,
      }
      getAction(this.url.loadEpDangerInfo, param).then((res) => {
        if (res.success) {
          const data = res.result
          this.epDanger = data
          /*if(model_code === "DelayForm"){
              getAction(this.url.loadEpDangerInfo,{formNo:data.dangerNo,modelCode:"HiddenDangerForm"}).then(res=>{
                if (res.success) {
                  /!*this.epDanger.dangerDescription = res.result.dangerDescription
                  this.epDanger.dangerLevel = res.result.dangerLevel
                  this.epDanger.dangerAddress = res.result.dangerAddress*!/
                  data.dangerDescription = res.result.dangerDescription
                  data.dangerLevel = res.result.dangerLevel
                  data.dangerAddress = res.result.dangerAddress
                  this.epDanger = data;
                }
              })
            }else{
              this.epDanger = data;
            }*/
        }
      })
    },

    beforeUpload: function (file) {
      var fileType = file.type
      if (fileType.indexOf('image') < 0) {
        this.$message.warning(this.language['warning.pleaseUploadImage'])
        return false
      }
      //TODO 验证文件大小
    },
  },
}
</script>

<style lang="less" scoped>
/deep/ .ant-card-body {
  padding: 5px;
  zoom: 1;
}
</style>